export default ['AU', 'EU', 'UK', 'US', 'EU/UK'];
